import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./footer";
import { useSelector } from "react-redux";

const Courses = () => {
    const [isLoader, setIsLoader] = useState(true);
    const loginInfo = useSelector((state) => state.login);
    const isLoggedIn = loginInfo.id !== undefined; // Check if loginInfo has an id

    useEffect(() => {
        // Simulating checking if the user is logged in
        setTimeout(() => setIsLoader(false), 1700);
    }, []);

    const courses = [
        { id: 1, img: "/python.jpeg" },
        { id: 2, img: "/SoftSkill.jpeg" },
        { id: 3, img: "/FullStack.jpeg" },
        { id: 4, img: "/FrontDev.jpeg" },
        { id: 5, img: "/SAP.jpeg" },
        { id: 6, img: "/Tally.jpeg" },
        { id: 7, img: "/SoftwareTesting.jpeg" },
        { id: 8, img: "/DataAnalytics.jpeg" },
        { id: 9, img: "/DataScience.jpeg" },
    ];

    return (
        <div  className="flex-container">
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="row" style={{flexGrow: "1"}}>
                    <div style={{ backgroundColor: "black", width: "100%" }}>
                        <h1 style={{ textAlign: "center", fontWeight: "bold", color: "#03e9f4", fontSize: "xxx-large" }}>
                            Courses
                        </h1>
                        <div className="courses-hp">
                            <div className="row grid-container">
                                {courses.map((course, index) => (
                                    <div key={course.id} className="col-3">
                                        <Link
                                            to={isLoggedIn ? `/course/${course.id}` : "/login"}
                                            className="courses-card courses-card-hover"
                                        >
                                            <img src={course.img} alt={`course-${index}`} />
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default Courses;
